import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-remaining-earnings',
  templateUrl: './tryout-remaining-earnings.component.html',
  styleUrls: ['./tryout-remaining-earnings.component.css']
})
export class TryoutRemainingEarningsComponent implements OnInit {

  @Input() RemainingEarnings: number;

  @Output() filterProgramsEvent = new EventEmitter();
  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterProgramListing(value) {
    this.program_status = value;
    this.filterProgramsEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-remaining-earnings/tryout-remaining-earnings.component.ts